// Types
import { SocialMediaType } from 'api/graphql-global-types';

export const deriveUsedPlatforms = (
  manualAccounts: { platform?: SocialMediaType }[],
  connectedPlatforms: Iterable<SocialMediaType>
): SocialMediaType[] => {
  const manual = manualAccounts
    .map((a) => a.platform)
    .filter((p): p is SocialMediaType => !!p);
  return Array.from(new Set([...manual, ...Array.from(connectedPlatforms)]));
};

export const firstAvailablePlatform = (
  allPlatforms: { value: SocialMediaType }[],
  usedPlatforms: SocialMediaType[]
): SocialMediaType | undefined =>
  allPlatforms.find((p) => !usedPlatforms.includes(p.value))?.value;
